async function getEveryBusiness() {
  const response = await fetch('/dashboard.json');

  return await response.json();
}

export default getEveryBusiness;
